import { ProjectBulkAddResult } from 'api/graphQL/types/projectBulk.types'
import { BulkAddBarType } from 'components/WorkspaceEditor/types/bulkAddBarStore.type'
import { create } from 'zustand'

/**
 * Creates a zustand store for managing bulk add bar  state
 */
export const useBulkAddBarStore = create<BulkAddBarType>()((set) => ({
    addBulkItemsInProgress: false,
    cancelBulkItems: false,
    addToProjectSuccess: false,
    bulkAddResponse: undefined,
    bulkAddErrorMessage: undefined,
    actions: {
        setAddBulkItemsInProgress: (value: boolean) => {
            set({ addBulkItemsInProgress: value })
        },
        setCancelBulkItems: (value: boolean) => {
            set({ cancelBulkItems: value })
        },
        setAddToProjectSuccess: (value: boolean) => {
            set({ addToProjectSuccess: value })
        },
        setBulkAddResponse: (
            value: Partial<ProjectBulkAddResult> | undefined
        ) => {
            set({ bulkAddResponse: value })
        },
        setBulkAddErrorMessage: (value?: string) => {
            set({ bulkAddErrorMessage: value })
        },
    },
}))
/** Zustand selector for getting the actions/setters. */
export const useBulkAddBarAction = () =>
    useBulkAddBarStore((state) => state.actions)
